import {Component, Input, OnInit} from '@angular/core';
import {FullUser} from '../../model';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.css']
})
export class UserCardComponent implements OnInit {
  @Input() user: FullUser;
  constructor() { }

  ngOnInit() {
  }

}
